import { Component } from '@angular/core';
import { DataProvider } from '../../providers/data.provider';
import { Router } from '@angular/router';
import { SpinnerProvider } from '../../components/spinner/spinner.provider';
import { SeoProvider } from '../../providers/seo.provider';

@Component({
  selector: 'page-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss']
})

export class ContactPage {
  formSubmit : any;

  constructor(seoProvider:SeoProvider, private router: Router, private spinner: SpinnerProvider) {
    seoProvider.setTitle("Angelcrypt | Contact Us");
  }
}



